var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Form, FormGroup, Label, Input, Button, InputGroupText, InputGroupAddon, FormFeedback, InputGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { getQueryParam } from '../../../utils/urlUtils';
import { createErrorResponse } from '../../../utils/errorUtils';
import Routes from '../../../routes/RoutesConfig';
import { FormErrorContext } from '../../../FormErrorContext';
import { ApplicationContext } from '../../../ApplicationContext';
import Page from '../Page';
import FormField from '../../components/ui/FormField/FormField';
import PasswordValidator from '../../components/ui/PasswordValidator/PasswordValidator';
import AcceptInvitationCommand from '../../../commands/authentication/AcceptInvitationCommand';
/**
 *
 */
var AcceptInvitation = /** @class */ (function (_super) {
    __extends(AcceptInvitation, _super);
    /**
     *
     */
    function AcceptInvitation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            register: true,
            matchingPasswords: false,
            showPassword: false,
            showMatchingPassword: false,
            password: "",
            passwordMatch: "",
            errors: []
        };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        return _this;
    }
    /**
     *
     */
    AcceptInvitation.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     */
    AcceptInvitation.prototype.initialize = function () {
        var invitationToken = getQueryParam('invitationToken');
        var email = getQueryParam('email').toLowerCase();
        this.setState({ invitationToken: invitationToken, email: email }, function () {
        });
    };
    /**
     *
     * @returns {*}
     */
    AcceptInvitation.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return (React.createElement(Page, { pageName: "accept-invitation" },
            React.createElement("div", { className: "container h-100 align-items-center" },
                React.createElement("div", { className: "row h-100 justify-content-center align-items-center text-white" },
                    React.createElement("div", { className: "col-md-8 col-lg-5 h-100" },
                        React.createElement("h2", { className: "card-header justify-content-center" },
                            React.createElement(FormattedMessage, { id: "page.acceptinvitation.title" })),
                        React.createElement("div", { className: "card-body h-75 overflow-auto" },
                            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                                React.createElement(Form, { onSubmit: this.onSubmit, autoComplete: "off" }, this.state.register ?
                                    // Register
                                    React.createElement("fieldset", { disabled: this.state.submitting },
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "firstname" },
                                                    React.createElement(FormattedMessage, { id: "page.acceptinvitation.field.firstname" })),
                                                React.createElement(Input, { name: "firstname", id: "firstname", onChange: this.onInputChange, required: true }))),
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "lastname" },
                                                    React.createElement(FormattedMessage, { id: "page.acceptinvitation.field.lastname" })),
                                                React.createElement(Input, { name: "lastname", id: "lastname", onChange: this.onInputChange, required: true }))),
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "email" },
                                                    React.createElement(FormattedMessage, { id: "page.login.field.email" })),
                                                React.createElement(Input, { name: "email", id: "email", value: this.state.email, disabled: true }))),
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "passwordRegister" },
                                                    React.createElement(FormattedMessage, { id: "page.acceptinvitation.field.password" })),
                                                React.createElement(InputGroup, null,
                                                    React.createElement(Input, { name: "passwordRegister", id: 'passwordRegister', invalid: ((_b = (_a = this.state.errors) === null || _a === void 0 ? void 0 : _a['passwordRegister']) === null || _b === void 0 ? void 0 : _b.length) > 0, type: this.state.showPassword ? "text" : "password", autoComplete: "new-password", required: true, onChange: this.onInputChange }),
                                                    React.createElement(InputGroupAddon, { addonType: 'append' },
                                                        React.createElement(InputGroupText, { className: "showPasswordButton " + ((!this.state.matchingPasswords && this.state.password) ? "active" : "") },
                                                            React.createElement("span", { onClick: function () {
                                                                    _this.setState({ showPassword: !_this.state.showPassword });
                                                                    _this.checkIfPasswordsMatch(_this.state.password, _this.state.passwordMatch);
                                                                }, className: "fe cursor-pointer " + (this.state.showPassword ? "fe-eye" : "fe-eye-off") }))), (_d = (_c = this.state.errors) === null || _c === void 0 ? void 0 : _c['passwordRegister']) === null || _d === void 0 ? void 0 :
                                                    _d.map(function (e) {
                                                        return (React.createElement(FormFeedback, { className: "d-none", invalid: true },
                                                            React.createElement(FormattedMessage, { id: e })));
                                                    })))),
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "passwordMatch" },
                                                    React.createElement(FormattedMessage, { id: "page.acceptinvitation.field.passwordMatch" })),
                                                React.createElement(InputGroup, null,
                                                    React.createElement(Input, { name: "passwordMatch", id: "passwordMatch", invalid: ((_f = (_e = this.state.errors) === null || _e === void 0 ? void 0 : _e['passwordMatch']) === null || _f === void 0 ? void 0 : _f.length) > 0, type: this.state.showMatchingPassword ? "text" : "password", autoComplete: "new-password", required: true, onChange: this.onInputChange }),
                                                    React.createElement(InputGroupAddon, { addonType: 'append' },
                                                        React.createElement(InputGroupText, { className: "showPasswordButton " + ((!this.state.matchingPasswords && this.state.password) ? "active" : "") },
                                                            React.createElement("span", { onClick: function () {
                                                                    _this.setState({ showMatchingPassword: !_this.state.showMatchingPassword });
                                                                    _this.checkIfPasswordsMatch(_this.state.password, _this.state.passwordMatch);
                                                                }, className: "fe cursor-pointer " + (this.state.showMatchingPassword ? "fe-eye" : "fe-eye-off") }))), (_h = (_g = this.state.errors) === null || _g === void 0 ? void 0 : _g['passwordMatch']) === null || _h === void 0 ? void 0 :
                                                    _h.map(function (e) {
                                                        return (React.createElement(FormFeedback, { className: "bg-danger text-white rounded py-2 px-3", invalid: true },
                                                            React.createElement(FormattedMessage, { id: e })));
                                                    })))),
                                        React.createElement(PasswordValidator, { value: this.state['password'] }),
                                        React.createElement(Button, { className: "w-100 ml-0 mb-3 font-weight-bolder", color: "dark", type: "submit", style: { fontSize: "larger", fontWeight: "bolder" } },
                                            React.createElement(FormattedMessage, { id: "page.acceptinvitation.register" })),
                                        React.createElement("p", { className: "text-center" },
                                            React.createElement("small", { className: "text-white text-center" },
                                                React.createElement(FormattedMessage, { id: "page.acceptinvitation.alreadyaccount" }),
                                                " ",
                                                React.createElement("a", { className: "text-white cursor-pointer", style: { textDecoration: "underline" }, onClick: function (e) { return _this.setState({
                                                        register: false,
                                                        password: "",
                                                        passwordMatch: ""
                                                    }); } },
                                                    React.createElement(FormattedMessage, { id: "page.acceptinvitation.login" })),
                                                ".")))
                                    :
                                        // Login
                                        React.createElement("fieldset", { disabled: this.state.submitting },
                                            React.createElement(FormGroup, null,
                                                React.createElement(FormField, { className: "justify-content-center" },
                                                    React.createElement(Label, { for: "email" },
                                                        React.createElement(FormattedMessage, { id: "page.login.field.email" })),
                                                    React.createElement(Input, { name: "email", id: "email", disabled: true, value: this.state.email }))),
                                            React.createElement(FormGroup, null,
                                                React.createElement(FormField, { className: "justify-content-center" },
                                                    React.createElement(Label, { for: "password" },
                                                        React.createElement(FormattedMessage, { id: "page.login.field.password" })),
                                                    React.createElement(InputGroup, null,
                                                        React.createElement(Input, { name: "password", id: 'password', invalid: ((_k = (_j = this.state.errors) === null || _j === void 0 ? void 0 : _j['password']) === null || _k === void 0 ? void 0 : _k.length) > 0, type: this.state.showPassword ? "text" : "password", autoComplete: "new-password", required: true, onChange: this.onInputChange }),
                                                        React.createElement(InputGroupAddon, { addonType: 'append' },
                                                            React.createElement(InputGroupText, { className: "showPasswordButton " + ((!this.state.matchingPasswords && this.state.password) ? "active" : "") },
                                                                React.createElement("span", { onClick: function () {
                                                                        _this.setState({ showPassword: !_this.state.showPassword });
                                                                        _this.checkIfPasswordsMatch(_this.state.password, _this.state.passwordMatch);
                                                                    }, className: "fe cursor-pointer " + (this.state.showPassword ? "fe-eye" : "fe-eye-off") }))), (_m = (_l = this.state.errors) === null || _l === void 0 ? void 0 : _l['password']) === null || _m === void 0 ? void 0 :
                                                        _m.map(function (e) {
                                                            return (React.createElement(FormFeedback, { invalid: true },
                                                                React.createElement(FormattedMessage, { id: e })));
                                                        })),
                                                    React.createElement(Link, { to: Routes.FORGOT_PASSWORD.path, className: "form-text small text-white", style: { textDecoration: "underline" } },
                                                        React.createElement(FormattedMessage, { id: "page.login.forgotpassword" })))),
                                            React.createElement(Button, { className: "w-100 ml-0 mb-3", color: "dark", type: "submit", style: { fontSize: "larger", fontWeight: "bolder" } },
                                                React.createElement(FormattedMessage, { id: "page.acceptinvitation.login" })),
                                            React.createElement("p", { className: "text-center" },
                                                React.createElement("small", { className: "text-white text-center" },
                                                    React.createElement(FormattedMessage, { id: "page.acceptinvitation.noaccount" }),
                                                    " ",
                                                    React.createElement("a", { className: "text-white cursor-pointer", style: { textDecoration: "underline" }, onClick: function (e) { return _this.setState({
                                                            register: true,
                                                            password: "",
                                                            passwordMatch: ""
                                                        }); } },
                                                        React.createElement(FormattedMessage, { id: "page.acceptinvitation.register" })),
                                                    ".")))))))))));
    };
    /**
     *
     * @param e
     */
    AcceptInvitation.prototype.onInputChange = function (e) {
        var nextState = {};
        switch (e.target.name) {
            case 'email':
                nextState[e.target.name] = e.target.value.toLowerCase();
                break;
            case 'passwordRegister':
                this.checkIfPasswordsMatch(e.target.value, this.state['passwordMatch']);
                nextState['password'] = e.target.value;
                break;
            case 'passwordMatch':
                this.checkIfPasswordsMatch(this.state['password'], e.target.value);
                nextState[e.target.name] = e.target.value;
                break;
            default:
                nextState[e.target.name] = e.target.value;
        }
        this.setState(nextState);
    };
    /**
     *
     * @param password
     * @param match
     */
    AcceptInvitation.prototype.checkIfPasswordsMatch = function (password, match) {
        if (password == match) {
            this.setState({ matchingPasswords: true, errors: [] });
        }
        else {
            var err = { passwordRegister: [" "], passwordMatch: ["error.passwordsDontMatch"] };
            this.setState({ matchingPasswords: false, errors: err });
        }
    };
    AcceptInvitation.prototype.doPasswordsMatch = function (password, match) {
        return password == match;
    };
    /**
     *
     * @param e
     */
    AcceptInvitation.prototype.onSubmit = function (e) {
        e ? e.preventDefault() : null;
        if (this.state.submitting) {
            return;
        }
        if (this.state.register) {
            if (!this.doPasswordsMatch(this.state.password, this.state.passwordMatch)) {
                return;
            }
        }
        var intl = this.props.intl;
        this.setState({ errors: null, submitting: true });
        var command = new AcceptInvitationCommand();
        command.execute(this.state, intl).then(this.onSuccess).catch(this.onError);
    };
    /**
     *
     */
    AcceptInvitation.prototype.onSuccess = function () {
        this.setState({ submitting: false });
    };
    /**
     *
     * @param error
     */
    AcceptInvitation.prototype.onError = function (error) {
        console.log(error.error.response.body.errors);
        if (this.state.register) {
            error.error.response.body.errors["passwordRegister"] = error.error.response.body.errors.password;
        }
        createErrorResponse(this, error);
    };
    /**
     *
     * @return {boolean}
     */
    AcceptInvitation.prototype.fieldsComplete = function () {
        var _a = this.state, firstname = _a.firstname, lastname = _a.lastname;
        return (firstname && firstname.length > 0) && (lastname && lastname.length > 0);
    };
    return AcceptInvitation;
}(React.Component));
AcceptInvitation.contextType = ApplicationContext;
export default injectIntl(AcceptInvitation);
